import React from 'react'

import QuizPreview from './components/QuizPreview'
import QuizEditor from './components/QuizEditor'
import useQuizModule from './hooks/useQuizModule'

export default function QuizModule({ name, isPreview = false, data, isCurrentThemeLight, completedModules }) {
  const quizModule = useQuizModule(name)

  if (isPreview && data) {
    return (
      <QuizPreview
        completedModules={completedModules}
        data={data}
        isCurrentThemeLight={isCurrentThemeLight}
        selectedOptionId={quizModule.selectedOptionId}
        selectedOptionIds={quizModule.selectedOptionIds}
        isAnswered={quizModule.isAnswered}
        isCorrect={quizModule.isCorrect}
        isPartiallyCorrect={quizModule.isPartiallyCorrect}
        handleOptionSelect={quizModule.handleOptionSelect}
        handleMultipleOptionSelect={quizModule.handleMultipleOptionSelect}
        handleMultipleSubmit={quizModule.handleMultipleSubmit}
        handleReset={quizModule.handleReset}
      />
    )
  }

  return (
    <QuizEditor
      name={name}
      isCurrentThemeLight={isCurrentThemeLight}
      contextError={quizModule.contextError}
      duplicateError={quizModule.duplicateError}
      emptyError={quizModule.emptyError}
      commentError={quizModule.commentError}
      handleContextChange={quizModule.handleContextChange}
      handleCommentChange={quizModule.handleCommentChange}
      handleQuizTypeChange={quizModule.handleQuizTypeChange}
      handleAddOption={quizModule.handleAddOption}
      handleDeleteOption={quizModule.handleDeleteOption}
      handleOptionChange={quizModule.handleOptionChange}
      handleOptionBlur={quizModule.handleOptionBlur}
      handleCorrectAnswerChange={quizModule.handleCorrectAnswerChange}
      MAX_CONTEXT_LENGTH={quizModule.MAX_CONTEXT_LENGTH}
      MAX_COMMENT_LENGTH={quizModule.MAX_COMMENT_LENGTH}
    />
  )
}
